import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-apierror-handling',
  templateUrl: './apierror-handling.component.html',
  styleUrls: ['./apierror-handling.component.scss']
})
export class APIErrorHandlingComponent implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  reloadPage() {
    window.location.reload();
  }

}
